import "./FAQ.module.css";
import Header from "@/reusable_sections/Header";
import Faq from "./sections/Faq";
export default function FAQPage() {
  return <div>
      <Header />
      <Faq />
    </div>;
}